import React, { useEffect, useRef } from "react";
import {closePopup, openPopup} from "utils/CommonUtils";

const KakaoMap = () => {
  const mapContainerRef = useRef(null); // 지도를 표시할 DOM 참조
  useEffect(() => {
    const { kakao } = window;
    if (!kakao) {
      console.error("Kakao Maps API가 로드되지 않았습니다.");
      return;
    }

    // 지도 생성
    const map = new kakao.maps.Map(mapContainerRef.current, {
      center: new kakao.maps.LatLng(37.5665, 126.9780), // 초기 중심 좌표 (서울)
      level: 3, // 지도 확대 레벨
    });

    // 마커 생성 (초기 중심에 표시)
    const marker = new kakao.maps.Marker({
      position: map.getCenter(),
      map: map, // 마커를 지도에 추가
    });

    // Geocoder 객체 생성
    const geocoder = new kakao.maps.services.Geocoder();

    // 클릭 이벤트 등록 (지도 클릭 시 마커 이동 및 좌표 업데이트)
    kakao.maps.event.addListener(map, "click", (mouseEvent) => {
      const latlng = mouseEvent.latLng; // 클릭한 위치의 좌표
      const lat2 = document.getElementById("lat2");
      const lng2 = document.getElementById("lng2");
      const road2 = document.getElementById("road2");
      const jibun2 = document.getElementById("jibun2");

      // 마커를 클릭한 위치로 이동
      marker.setPosition(latlng);

      // 입력 필드에 좌표 설정
      lat2.value = latlng.getLat().toFixed(6);
      lng2.value = latlng.getLng().toFixed(6);

      // 좌표를 주소로 변환
      geocoder.coord2Address(latlng.getLng(), latlng.getLat(), (result, status) => {
        if (status === kakao.maps.services.Status.OK) {
          const addressInfo = result[0].address;
          const roadAddr = result[0].road_address;

          // 도로명 주소와 지번 주소 업데이트
          road2.value = roadAddr ? roadAddr.address_name : "도로명 주소 없음";
          jibun2.value = addressInfo.address_name || "지번 주소 없음";
        } else {
          road2.value = "도로명 주소 없음";
          jibun2.value = "지번 주소 없음";
        }
      });
    });

    // 지도 중심 및 마커 갱신 함수
    const openEvent = () => {
      const lat = parseFloat(document.getElementById("latInput").value) || 37.5665;
      const lng = parseFloat(document.getElementById("lngInput").value) || 126.9780;
      console.log("test");
      openPopup("kakaoMap");

      // 지도 갱신 및 마커 이동
      setTimeout(() => {
        const newPosition = new kakao.maps.LatLng(lat, lng); // 새로운 좌표 생성
        map.relayout(); // 지도 크기 재조정
        map.setCenter(newPosition); // 새 좌표로 중심 이동
        marker.setPosition(newPosition); // 마커를 새로운 좌표로 이동
      }, 0);
    };

    // 버튼 클릭 이벤트 등록
    const mapBtn = document.getElementById("mapBtn");
    mapBtn.addEventListener("click", openEvent);

    // 컴포넌트 언마운트 시 이벤트 정리
    return () => {
      kakao.maps.event.removeListener(map, "click");
      mapBtn.removeEventListener("click", openEvent);
    };
  }, []);

  const completeBtn = () => {
    const lat2 = document.getElementById("lat2");
    const lng2 = document.getElementById("lng2");
    const road2 = document.getElementById("road2");
    const jibun2 = document.getElementById("jibun2");
    
    if (lat2.value === "") {
      alert("위도 값이 없습니다.")
      return false;
    }
    if (lng2.value === "") {
      alert("경도 값이 없습니다.")
      return false;
    }
    if (road2.value === "" || road2.value === "도로명 주소 없음") {
      alert("도로명 주소가 없습니다.")
      return false;
    }
    if (jibun2.value === "" || jibun2.value === "지번 주소 없음") {
      alert("지번 주소가 없습니다.")
      return false
    }

    const lat = document.getElementById("latInput");
    const lng = document.getElementById("lngInput");
    const road = document.getElementById("roadInput");
    const jibun = document.getElementById("jibunInput");
    lat.value = lat2.value;
    lng.value = lng2.value;
    road.value = road2.value;
    jibun.value = jibun2.value;

    closePopup("kakaoMap");
  }

  return (
    <div id="kakaoMap" className="kakaoMap hide bg-white">
      <p className="title">지도로 주소 검색</p>
      <div
        ref={mapContainerRef}
        style={{
          width: "400px",
          height: "400px",
        }}
      ></div>
      <div className="textBox pt-5 pb-5 pl-5 pr-5">
        <div className="d-flex a-center j-left mb-5"><label>도로명 : </label><input id="road2" type="text" /></div>
        <div className="d-flex a-center j-left mb-5"><label>위도 : </label><input id="lat2" type="text" /></div>
        <div className="d-flex a-center j-left mb-5"><label>경도 : </label><input id="lng2" type="text" /></div>
        <div className="d-flex a-center j-left"><label>지번 주소 : </label><input id="jibun2" type="text" /></div>
      </div>
      <div>
        <button className="btn kakaoMapCompleteBtn bg-blue fc-white" onClick={completeBtn}>적용</button>
        <button className="btn kakaoMapCloseBtn" onClick={() => closePopup("kakaoMap")}>닫기</button>
      </div>
    </div>
  );
};

export default KakaoMap;
